import React from "react"
import Fade from "react-reveal/Fade"
import data from "../yourdata"

const About = () => {
  return (
    <div className="secion" id="about">
      <div className="container">
        <div className="about-section">
          <div className="content">
            <Fade bottom cascade>
              <h1>About Me</h1>
            </Fade>
            <p>
              👋 I'm Alysia. I am an entrepreneur, product builder in tech &
              design. Here's my story.
              <br></br>
              <p>
                👩🏼‍🎓 🏫 I'm studied materials science and engineering 🧪 in
                university and did nanoparticle synthesis research 👩‍🔬 🔬 in
                graduate school, got my PhD degree from{" "}
                <a href="https://thecollege.syr.edu/chemistry/">
                  Syracuse University
                </a>
                .{" "}
              </p>
              <p>
                👩‍💻 I did a 12 weeks intensive coding bootcamp trainning from
                coding dojo, and started working in Tech at Silicon valley 💪.
              </p>
              <p>
                🎯 Working at companies from big tech to unicorn scale startups
                💵 🎉 ☕ , honing my skills at product building and software
                architectural system design, while keeping up with the latest
                hotest tech via youtube, twitter, varies of medium, DEV to blogs
                posts, as well as online courses from varies of sources.
                {/* and now I am exploring my next chapter 🧘‍♀️ 🏖️ 📈 🎉 ✨ ! */}
              </p>
              <p>
                👏 Outside of programming, I enjoy learning more about all
                aspects of lean startups and Zumba and Hip-Pop dancing 💃.
                {/* and now I am exploring my next chapter 🧘‍♀️ 🏖️ 📈 🎉 ✨ ! */}
              </p>
              <br></br>
              {/* My app has been featured on Product Hunt #1, Lifehacker, tech blogs in 7 countries, and Hacker Noon 2020 Noonies Award. */}
              <br></br>
              <h2>If you are passionate about those, let's connect! 👩 💼 </h2>
              {/* <p> — Working with international clients (US/APAC) in B2B</p> */}
              {/* <p>Consulting — Working with international clients (US/APAC) in B2B</p> */}
              <p>🛠️ Building — Tools for developer experience</p>
              <p>🚀 Launching — Startups</p>
              <p>🐱‍💻 Weekend — Productivity hacking</p>
              {/* <div
                class="cui-embed"
                style="height: 400px; width: 100%;"
                data-cui-uid="aAWiOJU7"
                data-cui-avatar="https://images.typeform.com/images/6JZ72w9sksUt"
                data-cui-mode="widget"
                data-cui-pill-button-color="#0000FF"
              ></div> */}
              {/* <p>Weekend — Hacking productivity Notion TrackerSuite, Product2kit & growing Newsletter</p> */}
              <br></br>
              {/* I also consult teams and tech cos in product communication & user base discovery. */}
            </p>
          </div>
          {/* TODO: can add some highlighting pictures */}
          {/* <div className="image-wrapper">
            <img src={data.aboutImage} alt="about"></img>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default About
